import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-add-book-per-price-component1',
  // standalone: true,
  // imports: [],
  templateUrl: './add-book-per-price-component1.component.html',
  styleUrl: './add-book-per-price-component1.component.scss'
})
export class AddBookPerPriceComponent1Component {
  bookreceipt;
    bookdata = [];
    updatedBooks = [];
    initial_total_val: number = 0;
    crdtvAmt = 0;
    
    selectedAmt = 0;
    balanceAmt = 0;
    bal =0;
    bname:any;
  bname_from_voucher: any;

    constructor(
      public service: DigisubservicesService,
      private fb: FormBuilder,
      private dialogRef: MatDialogRef<AddBookPerPriceComponent1Component>,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {
     
    }
  
   ngOnInit(): void {
  debugger;
  this.bookreceipt = this.data['book'];

  // Correct key from backend
  // this.crdtvAmt = isNaN(this.data['crdtAmt']) ? 0 : this.data['crdtAmt'];
  this.selectedAmt = isNaN(this.data['seAmt']) ? 0 : this.data['seAmt'];
  this.balanceAmt = isNaN(this.data['balAmt']) ? 0 : this.data['balAmt'];
  this.bal = isNaN(this.data['bal']) ? 0 : this.data['bal'];
  this.bname = this.data?.['bookName'] ?? '';

  this.crdtvAmt = this.balanceAmt + this.selectedAmt;

  // console.log('Credit Voucher Amount:', this.crdtvAmt);
  console.log('Book Name:', this.bname);
  console.log('Receipt Data:', this.bookreceipt);

  const fetchBooks = this.service.getRcptWiseBooks1(this.bookreceipt['order_no']);
 fetchBooks.subscribe((data) => {
  data.forEach((book) => {
    const total_amount = parseInt(book['total']) + parseInt(book['shipping_charges']);
    const rcvd_amt = parseInt(book['received_amt']) || 0;
    const remaining_amt: number = total_amount - rcvd_amt;

    this.total_val += rcvd_amt;
    this.total_remaining_amt += remaining_amt;

    this.bookdata.push({
      id: this.bookreceipt['id'],
      bookid: book['bd_id'],
      book_name: book['book_name'],        // from BookData
      book_names: book['book_names'],      // from book_names table
      book_price: book['book_price'],
      book_copies: book['book_copies'],
      total: book['total'],
      shipping_charges: book['shipping_charges'],
      rep_name: book['rep_name'],
      office_rep_name: book['office_rep_name'],
      total_amount: total_amount,
      rcvd_amt: rcvd_amt,
      remaining_amt: remaining_amt,
      invoice_no: this.bookreceipt['invoice_no'],
      isDisabled: remaining_amt === 0,
      order_no: book['order_no']
    });
  });

  // ✅ Example: Bind first record’s names for display
  if (this.bookdata.length > 0) {
    this.bname = this.bookdata[0].book_name || '';
    this.bname_from_voucher = this.bookdata[0].book_names || '';
  }

  console.log("Book Data:", this.bookdata);
});

}

  
    total_remaining_amt = 0;
    total_val = 0;
    value = 0;
    newvalue=0;
  
   calcamount(event: any, book: any) {
    debugger;
    let val = parseInt(event.target.value) || 0; // ensure number
  
    // 1️⃣ Check per-book: entered value cannot be more than book's remaining amount
    let remaining_amt_check =
      (parseInt(book['total_amount']) || 0) - (parseInt(book['rcvd_amt']) || 0);
  
    if (val > remaining_amt_check) {
      alert("Received amount cannot be greater than book's remaining amount!");
      event.target.value = book['rcvd_amt'] || 0;
      return;
    }
  
    // 2️⃣ Check against total Credit Voucher amount (with other books included)
    // First calculate total of all other books
    let otherBooksTotal = this.bookdata.reduce((sum: number, b: any) => {
      if (b.bookid !== book.bookid) {
        return sum + (parseInt(b.rcvd_amt) || 0);
      }
      return sum;
    }, 0);
  
    let totalIfThisAccepted = otherBooksTotal + val;
    if (totalIfThisAccepted > this.crdtvAmt) {
      alert("Received amount cannot be greater than Credit Voucher Amount!");
      event.target.value = book['rcvd_amt'] || 0; // reset to old value
      return;
    }
  
    // ✅ Passed validation → update book
    let remaining_amt =
      (parseInt(book['total_amount']) || 0) - val;
  
    let updatedBook = { ...book };
    updatedBook['rcvd_amt'] = val;
    updatedBook['remaining_amt'] = remaining_amt;
    updatedBook['isDisabled'] = remaining_amt === 0;
  
    // Update in updatedBooks list
    let index = this.updatedBooks.findIndex(b => b.bookid === book.bookid);
    if (index !== -1) {
      this.updatedBooks[index] = updatedBook;
    } else {
      this.updatedBooks.push(updatedBook);
    }
  
    // Update in bookdata
    let bookIdx = this.bookdata.findIndex(b => b.bookid === book.bookid);
    if (bookIdx !== -1) {
      this.bookdata[bookIdx] = updatedBook;
    }
  
    // 🔄 Recalculate totals from scratch (avoid double-counting)
    this.total_val = this.bookdata.reduce(
      (sum: number, b: any) => sum + (parseInt(b.rcvd_amt) || 0), 0
    );
  
    this.total_remaining_amt = this.bookdata.reduce(
      (sum: number, b: any) => sum + (parseInt(b.remaining_amt) || 0), 0
    );
  
    this.selectedAmt = this.total_val;
    this.balanceAmt = this.crdtvAmt - this.selectedAmt;
    // this.crdtvAmt = this.balanceAmt + this.selectedAmt;
    this.crdtvAmt = this.balanceAmt + this.selectedAmt;

  
    console.log("bookdata", this.bookdata);
    console.log("selectedAmt", this.selectedAmt, "balanceAmt", this.balanceAmt);
  }
  
  
  
  
    
  
  
    // save() {
    //   console.log(this.value);
  
    //   this.dialogRef.close({
    //     data: this.updatedBooks,
    //     selecetdAmt: this.selectedAmt,
    //     remaining_amt: this.total_remaining_amt,
    //     value: this.value,
    //     balanceAmt: this.balanceAmt,
    //     id: this.bookreceipt['id'],
    //   });
    //   // if (confirm('This operation is not reversable. Do you want to proceed.')) {
    //   //   for (let index = 0; index < Object.keys(this.bookdata).length; index++) {
    //   //     this.service
    //   //       .updateRcptWiseBooks(
    //   //         this.bookdata[index]['bookid'],
    //   //         this.bookdata[index]['rcvd_amt'],
    //   //         this.bookdata[index]['remaining_amt']
    //   //       )
    //   //       .subscribe((data) => {
    //   //         console.log(data);
    //   //         alert('Books price added successfully...');
    //   //         // this.dialogRef.close();
    //   //       });
    //   //   }
    //   // }
    // }
  }
  
  


